import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import settings from "@/scripts/common/settings"
import { addScrollController } from "@/scripts/common/api/scrolltrigger.services"

gsap.registerPlugin(ScrollTrigger);

export default class PinBothDirection {
    constructor(pin, options) {
        
        this.element = pin
        this.scrollController = null
        this.options = Object.assign({
            start: this.element.dataset.start || "top top",
            trigger: this.element.dataset.startTrigger || this.element,
            endTrigger: this.element.dataset.endTrigger || 'window',
            end: self =>  "bottom bottom" + (window.innerHeight > self.trigger.offsetHeight ? "-=" + (window.innerHeight - self.trigger.offsetHeight) : ""),
        }, {
            ...options
        })
        this.init()
    }

    init() {
        this.updateSidebar()
        this.#_addingEventListeners()
    }

    stickyBothDirections() {
        let vars = this.options;
        let element = this.element;
        let keywords = { top: "0", center: "50%", bottom: "100%" },
            scrollFunc = ScrollTrigger.getScrollFunc(window),
            overlap, topOffset,
            updateOverlap = () => {
                topOffset = ((typeof (vars.start) === "function" ? vars.start() : vars.start || "0 0") + "").split(" ")[1] || "0";
                let offsetMatch = topOffset.match(/([\+\-]=)(\d+)/);
                topOffset = keywords[topOffset] || topOffset;
                topOffset = ~topOffset.indexOf("%") ? parseFloat(topOffset) / 100 * window.innerHeight : parseFloat(topOffset) || 0;

                // If there is an offset adjustment (+= or -=), apply it
                if (offsetMatch) {
                    let operator = offsetMatch[1]; // += or -=
                    let value = parseFloat(offsetMatch[2]); // The numeric value after += or -=
                    
                    if (operator === "+=") {
                        topOffset += value;
                    } else if (operator === "-=") {
                        topOffset -= value;
                    }
                }
                
                console.log(topOffset)
                overlap = Math.max(0, element.offsetHeight - window.innerHeight + topOffset);
            },
            { onUpdate, onRefresh } = vars,
            offset = 0,
            lastY = 0,
            pinned,
            pin = (value, bottom) => {
                pinned = value;
                if (pinned) {
                    let bounds = element.getBoundingClientRect();
                    gsap.set(element, {
                        position: "fixed",
                        left: bounds.left,
                        width: bounds.width,
                        boxSizing: "border-box",
                        y: 0,
                        top: bottom ? topOffset - overlap : topOffset
                    });
                } else {
                    gsap.set(element, {
                        position: "relative",
                        clearProps: "left,top,width,boxSizing",
                        y: offset
                    });
                }
            },
            self;
        updateOverlap();
        vars.trigger = element;
        vars.start = "start" in vars ? vars.start : "top top";
        vars.onRefresh = self => {
            updateOverlap();
            self.vars.onUpdate(self);
            onRefresh && onRefresh(self);
        };
        vars.onRefreshInit = self => {
            self.progress = 0;
            self.isActive = false;
            vars.onUpdate(self);
        };
        vars.onUpdate = self => {
            let { progress, start, end, isActive } = self,
                y = progress * (end - start),
                delta = y - lastY,
                exceedsBottom = y + Math.max(0, delta) >= overlap + offset;
            if ((exceedsBottom || y + Math.min(0, delta) < offset) && isActive) {
                offset += exceedsBottom ? y - overlap - offset : y - offset;
                pinned || pin(true, exceedsBottom);
                // uncomment if you want to prioritize showing the TOP of the sidebar.
                // } else if (!exceedsBottom && y + offset < overlap && isActive) {
                //   offset += y - offset;
                //   pinned || pin(true, false);
            } else if (pinned || !isActive) {
                isActive || (offset = y ? self.end - self.start - overlap : 0);
                pin(false);
            }
            lastY = y;
            onUpdate && onUpdate(self);
        };
        self = ScrollTrigger.create(vars);
        return self;
    }

    updateSidebar() {
        if (this.scrollController) {
            this.scrollController.vars.onRefreshInit(sideBarST);
            this.scrollController.kill();
        }
        this.scrollController = this.stickyBothDirections();
        addScrollController(this.scrollController)
    }

    // Callbacks
    refresh() {
        this.scrollController.refresh()
    }

    destroy() {
        this.scrollController.kill();
    }


    #_addingEventListeners() {
        window.addEventListener('majorlayoutChange', () => this.refresh())
    }
}
